import { useState, useEffect } from 'react';
import { Visibility, VisibilityOff, Close, LockOutlined } from '@mui/icons-material';

const PasswordConfirmDialog = ({ open, onClose, onConfirm, anchorEl, flag, onResetPassword }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [position, setPosition] = useState({});

  // flag === 0 means new user (set password), flag === 1 means existing user (verify)
  const isNewUser = flag === 0;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (open && anchorEl) {
      const rect = anchorEl.getBoundingClientRect();
      if (!isMobile) {
        setPosition({
          position: 'fixed',
          top: rect.bottom + 8,
          right: window.innerWidth - rect.right,
          left: 'auto',
        });
      }
    }
  }, [open, anchorEl, isMobile]);

  if (!open) return null;

  const handleSubmit = () => {
    if (!password) {
        setError('Please enter your password');
        return;
    }
    // ✅ Length validation 4 to 6
    if (password.length < 4 || password.length > 6) {
        setError('Password must be 4 to 6 characters');
        return;
    }
    if (!confirmPassword) {
        setError('Please confirm your password');
        return;
    }
    if (confirmPassword.length < 4 || confirmPassword.length > 6) {
        setError('Confirm password must be 4 to 6 characters');
        return;
    }
    if (password !== confirmPassword) {
        setError('Passwords do not match!');
        return;
    }

    setError('');
    setPassword('');
    setConfirmPassword('');
    // ✅ String format mein pass karo
    onConfirm(String(password), String(confirmPassword));
};
  const handleClose = () => {
    setError('');
    setPassword('');
    setConfirmPassword('');
    onClose();
  };

  const overlayStyle = isMobile ? {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    zIndex: 9998,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
  } : {
    position: 'fixed',
    inset: 0,
    zIndex: 9998,
    pointerEvents: 'none',
  };

  const cardStyle = isMobile ? {
    width: '100%',
    maxWidth: '380px',
    pointerEvents: 'all',
  } : {
    ...position,
    width: '300px',
    pointerEvents: 'all',
  };

  return (
    <>
      <div style={overlayStyle} onClick={isMobile ? handleClose : undefined}>
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            ...cardStyle,
            background: '#ffffff',
            borderRadius: '14px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            overflow: 'hidden',
            fontFamily: "'Segoe UI', sans-serif",
          }}
        >
          {/* Header */}
          <div style={{
            background: '#f8f9fa',
            borderBottom: '1px solid #ebebeb',
            padding: '14px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                background: isNewUser ? '#e6f4ea' : '#e8f0fe',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <LockOutlined style={{ fontSize: 15, color: isNewUser ? '#2e7d32' : '#1a73e8' }} />
              </div>
              <span style={{ fontWeight: 600, fontSize: '14px', color: '#1a1a1a' }}>
                {isNewUser ? 'Set Withdraw Password' : 'Verify Withdraw'}
              </span>
            </div>
            <button onClick={handleClose} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              width: 28, height: 28, borderRadius: '50%',
              color: '#888',
            }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0f0f0'}
              onMouseLeave={e => e.currentTarget.style.background = 'none'}
            >
              <Close style={{ fontSize: 16 }} />
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: '18px 16px 16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>

            {/* Subtitle for new user */}
            {isNewUser && (
              <p style={{
                margin: 0,
                fontSize: '12px',
                color: '#666',
                lineHeight: '1.5',
                background: '#f0f7ff',
                borderRadius: '6px',
                padding: '8px 12px',
              }}>
                🔐 Set a secure password to protect your withdrawals.
              </p>
            )}

            {/* Password Field */}
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                style={{
                  width: '100%',
                  padding: '10px 40px 10px 14px',
                  border: '1.5px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '13px',
                  color: '#222',
                  outline: 'none',
                  boxSizing: 'border-box',
                  transition: 'border-color 0.2s',
                  background: '#fafafa',
                }}
                onFocus={e => e.target.style.borderColor = isNewUser ? '#2e7d32' : '#1a73e8'}
                onBlur={e => e.target.style.borderColor = '#e0e0e0'}
              />
              <button onClick={() => setShowPassword(!showPassword)} style={{
                position: 'absolute', right: 10, top: '50%',
                transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#888', display: 'flex', padding: 0,
              }}>
                {showPassword
                  ? <VisibilityOff style={{ fontSize: 18 }} />
                  : <Visibility style={{ fontSize: 18 }} />}
              </button>
            </div>

            {/* Confirm Password Field — only for new users (flag === 0) */}
           
              <div style={{ position: 'relative' }}>
                <input
                  type={showConfirm ? 'text' : 'password'}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => { setConfirmPassword(e.target.value); setError(''); }}
                  style={{
                    width: '100%',
                    padding: '10px 40px 10px 14px',
                    border: '1.5px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '13px',
                    color: '#222',
                    outline: 'none',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.2s',
                    background: '#fafafa',
                  }}
                  onFocus={e => e.target.style.borderColor = '#2e7d32'}
                  onBlur={e => e.target.style.borderColor = '#e0e0e0'}
                />
                <button onClick={() => setShowConfirm(!showConfirm)} style={{
                  position: 'absolute', right: 10, top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer',
                  color: '#888', display: 'flex', padding: 0,
                }}>
                  {showConfirm
                    ? <VisibilityOff style={{ fontSize: 18 }} />
                    : <Visibility style={{ fontSize: 18 }} />}
                </button>
              </div>
         

            {/* Error */}
            {error && (
              <div style={{
                background: '#fff0f0',
                border: '1px solid #ffcdd2',
                borderRadius: '6px',
                padding: '8px 12px',
                fontSize: '12px',
                color: '#c62828',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}>
                ⚠️ {error}
              </div>
            )}

            {/* Buttons */}
            <div style={{ display: 'flex', gap: '10px', marginTop: '2px' }}>
              <button
                onClick={handleClose}
                style={{
                  flex: 1, padding: '10px',
                  border: '1.5px solid #e0e0e0',
                  borderRadius: '8px',
                  background: '#fff',
                  color: '#555',
                  fontWeight: 600,
                  fontSize: '13px',
                  cursor: 'pointer',
                  letterSpacing: '0.3px',
                  transition: 'all 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#f5f5f5'; e.currentTarget.style.borderColor = '#bbb'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e0e0e0'; }}
              >
                CANCEL
              </button>
              <button
                onClick={handleSubmit}
                style={{
                  flex: 1, padding: '10px',
                  border: 'none',
                  borderRadius: '8px',
                  background: isNewUser ? '#2e7d32' : '#1a73e8',
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '13px',
                  cursor: 'pointer',
                  letterSpacing: '0.3px',
                  transition: 'background 0.15s',
                  boxShadow: isNewUser
                    ? '0 2px 8px rgba(46,125,50,0.25)'
                    : '0 2px 8px rgba(26,115,232,0.25)',
                }}
                onMouseEnter={e => e.currentTarget.style.background = isNewUser ? '#1b5e20' : '#1557b0'}
                onMouseLeave={e => e.currentTarget.style.background = isNewUser ? '#2e7d32' : '#1a73e8'}
              >
                {isNewUser ? 'SET PASSWORD' : 'CONFIRM'}
              </button>
            </div>
{!isNewUser && (
  <div style={{ textAlign: 'center', marginTop: '8px' }}>
    <span
      style={{
        fontSize: '12px',
        color: '#1a73e8',
        cursor: 'pointer',
        textDecoration: 'underline',
      }}
      onClick={() => onResetPassword()}
    >
      Reset Password?
    </span>
  </div>
)}
            
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordConfirmDialog;